// extracted by mini-css-extract-plugin
export default {"movieCard":"MovieCard_movieCard__779Nd","movieImg":"MovieCard_movieImg__pCn6C"};